<template>
  <div>
    <!-- 直播 -->
    <div class="ifbox">
      <iframe id="iframeLive" ref="iframeLive" class="iframeLive" height="1325" width="1500" scrolling="no"
        frameborder="0" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"
        oallowfullscreen="true" msallowfullscreen="true" :src="LiveSrc"></iframe>
      <div class="ifRight"></div>
      <div class="ifLeft"></div>
      <div class="ifTop"></div>
      <div class="ifBot"></div>
      <div class="ifMid"></div>
    </div>
    <div class="EC_width bodytop">
      <div class="btitle display_center_ud">
        <img src="../../assets/img/icon/live.png" alt="">
        <div v-for="(item, index) in menulist" :key="index">
          <span v-show="index != 0" style="margin:0 10px;">/</span>
          <span :style="showBoxId == index ? 'cursor: pointer;color:#0b8586' : 'cursor: pointer;'"
            @click="showBoxId = index">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="EC_width body display_column">
      <div class="mobile">
        <el-popover placement="bottom-start" width="280" trigger="hover">
          <div class="mobbox">
            <div class="mobboxl">
              <img :src="mobUrl" alt="">
            </div>
            <div class="mobboxr">
              <p class="mobboxr1">扫码进入移动端观看页</p>
              <p class="mobboxr2">推荐使用微信扫一扫</p>
            </div>
          </div>
          <div slot="reference" class="mobbtn">
            <img src="../../assets/img/icon/mobile.png" alt="">
            <span>手机观看</span>
          </div>
        </el-popover>
      </div>
      <div class="bodyBox display_column" v-for="(item, index) in menulist" :key="index">
        <!-- <div class="btitle display_center_ud">
          <img src="../../assets/img/icon/live.png"
               alt="">
          <span>{{item.name}}</span>
        </div> -->
        <div class="bbox" v-if="showBoxId == index">
          <!-- 图文 -->
          <div class="tuwenbox" v-if="item.type == 2">
            <div v-if="item.liveDetailList.length > 0" v-html="item.liveDetailList[0].contents"></div>
          </div>
          <!-- 视频 -->
          <div class="wrap_content" v-else-if="item.type == 3">
            <swiper :options="swiperOption2">
              <swiper-slide v-for="(items, indexs) in item.liveDetailList" :key="indexs + 's'" @click="breadclk(items)">
                <div class="video-card">
                  <img :src="items.coverPictureUrl" class="cont_img" alt="">
                  <img src="../../assets/img/icon/bofang3.png" class="btn" @click="toShipin(items)" alt="">
                  <p class="title ng-star-inserted">
                    {{ items.title }}
                  </p>
                </div>
              </swiper-slide>
            </swiper>
            <div class="prevbutton2 el-icon-arrow-left"></div>
            <div class="nextbutton2 el-icon-arrow-right"></div>
          </div>
          <!-- 超级链接 -->
          <div class="wrap_content linkBox" v-else-if="item.type == 4">
            <swiper :options="swiperOption1">
              <swiper-slide v-for="(items, indexs) in item.liveDetailList" :key="indexs + 's'" @click="linkclk(items)">
                <div class="display_center_lr" style="width:100%" v-if="items.coverPictureUrl != ''">
                  <img :src="items.coverPictureUrl" style="cursor: pointer" width="230px" height="300px;" />
                </div>
              </swiper-slide>
            </swiper>
            <div class="prevbutton1 el-icon-arrow-left"></div>
            <div class="nextbutton1 el-icon-arrow-right"></div>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="isShipin" :title="shipinTitle" :before-close="shipinClose" width="700px">
        <div id="shipin"></div>
      </el-dialog>
    </div>
    <footer_index></footer_index>
  </div>
</template>

<script>
import format from '@/assets/unit/unit.js';
import footer_index from '../home/footer_index.vue';
import Player from 'xgplayer';
export default {
  name: "huodeLive",
  components: {
    footer_index
  },
  data() {
    return {
      lId: '',
      LiveSrc: '',
      menulist: [],
      menutype: 0,
      linkList: [],
      breadList: [],
      content: '',
      AuthorId: '',
      swiperOption2: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 10,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled'
        }
      },
      swiperOption1: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 10,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton1',
          prevEl: '.prevbutton1',
          disabledClass: 'my-button-disabled'
        }
      },
      isShipin: false,
      shipinTitle: '',
      player: null,
      mtgId: 0,
      liveType: 2,
      mobUrl: '',
      qid: 0,
      showBoxId: 0
    }
  },
  methods: {
    formatTime(datatime, timeformat) {
      return format(datatime, timeformat);
    },
    //排序
    sortKey(array, key) {
      return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },
    //获取授权地址
    GetUserAuth() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/GetHuodeViewUrl', {
        roomid: this.lId,
        userid: this.AuthorId
      }).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          //预览地址 + 控制页面样式的参数
          _this.LiveSrc = data + '&nav=false&info=false&onlyVideo=true';
          //   +"&nav=false&info=false&onlyVideo=true"
        }
      });
    },
    //
    //获取菜单
    getLiveMenuById() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/getLiveMenuById', {
        Id: this.lId,
        LiveType: 2
      }).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          _this.menulist = data;
        }
      });
    },
    getMeetingInfo() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/GetHuodeLiveById', {
        roomid: _this.lId
      }).then(res => {
        if (res.data.result == 'OK') {
          document.title = res.data.room.name || '全科医学网'
        }
      });
    },
    //超级链接跳转
    linkclk(item) {
      window.open(item.hyperlinks);
    },
    toShipin(item) {
      this.shipinTitle = item.title
      this.isShipin = true
      var test1 = setTimeout(() => {
        this.player = new Player({
          id: 'shipin',
          url: item.resUrl,
          autoplay: true,
          playsinline: true,
          width: '100%',
          height: 'auto'
        });
        clearTimeout(test1);
      }, 100);
    },
    shipinClose() {
      if (this.player != null) {
        this.player.destroy();
        this.player = null;
      }
      this.isShipin = false
    },
    // 判断是手机还是pc
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    regclick() {
      if (this.$cookies.isKey('token_chinagp')) {
        var _tokenkey = this.$cookies.get('token_chinagp');
        this.httphelper
          .post('/api/LoginApi/CheckToken', {
            tokenKey: _tokenkey
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.mobile == '' || res.data.data == null) {
                this.Defconfirm();
                return;
              }
              window.open('https://meeting.gp519.com/reg?mtgid=' + this.mtgId, '_blank');
            } else {
              let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
              this.toPcLogin(callback)

            }
          });
      } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
        'tokenkey')) {
        this.httphelper
          .post('/api/LoginApi/CheckToken', {
            tokenKey: this.$route.query.tokenkey
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.mobile == '' || res.data.data == null) {
                this.Defconfirm();
                return;
              }
              window.open('https://meeting.gp519.com/reg?mtgid=' + this.mtgId, '_blank');
            } else {
              let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
              this.toPcLogin(callback)
            }
          });
      } else {
        var hrefurl = '';
        hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
        let callback = encodeURIComponent(hrefurl);
        this.toPcLogin(callback)
      }
    },
    Defconfirm() {
      this.$confirm('会议报名必须先完善个人信息, 是否前往用户中心完善个人信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({ name: 'userInfor' });
      });
    },
    toPcLogin(cback) {
      var mtgId = 0
      if (this.$route.query.id != '' && this.$route.query.id != null && this.$route.query.id != '0') {
        mtgId = this.$route.query.id;
      }
      this.httphelper.post('/api/LiveApi/GetLiveRegistSetById', {
        id: mtgId.toString(),
        liveType: parseInt(this.liveType),
      }).then(res => {
        if (res.data.code == 200) {
          let callback = cback
          if (cback == 'default') callback = encodeURIComponent(window.location.href);
          if (res.data.data.siteType == 2) {
            window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback + '&type=2';
          } else {
            window.location.href = this.httphelper.IsDebugGP519() + '/loginIndex/login?callback=' + callback;
          }

        }
      })
    },
    //跳转直播
    toLive() {
      let _this = this
      _this.lId = this.$route.query.id
      if (_this.$route.query.mid != '' && _this.$route.query.mid != null && _this.$route.query.mid != '0') {
        _this.mtgId = _this.$route.query.mid;

      } else {
        _this.mtgId = 0
      }
      //验证是否需要报名
      _this.httphelper.post('/api/LiveApi/GetLiveRegistSet', {
        liveId: _this.lId.toString(),
        liveType: parseInt(_this.liveType),
        mtgId: parseInt(_this.mtgId),
        userId: parseInt(_this.AuthorId)
      }).then(res => {
        if (res.data.code != 200) {
          //请先报名
          this.$alert(res.data.msg, '提示', {
            confirmButtonText: '确定', callback: action => {
              _this.regclick();
            }
          });
        } else {
          // if (_this.mtgId > 0) {
          _this.CheckIsQuestionnaire();
          // } else {
          //   _this.getMeetingInfo()
          //   //获取授权地址
          //   _this.GetUserAuth();
          //   //菜单绑定
          //   _this.getLiveMenuById();
          //   _this.httphelper.post('/api/QRCoder/GetQRCode', {
          //     url: window.location.href.replace(/huodeLive/, "huodeLiveMobile")
          //   })
          //     .then(res => {
          //       if (res.data.code == 200) {
          //         _this.mobUrl = 'data:image/png;base64,' + res.data.data
          //       }
          //     })

          // }
        }
      });
    },
    //验证是否需要问卷
    CheckIsQuestionnaire() {
      this.httphelper.get('/api/LiveApi/CheckIsQuestionnaire?mid=' + this.mtgId + '&liveid=' + this.lId + '&livetype=' + parseInt(this.liveType)).then(res => {
        if (res.code == 200) {
          this.getMeetingInfo()
          //获取授权地址
          this.GetUserAuth();
          //菜单绑定
          this.getLiveMenuById();
          this.httphelper.post('/api/QRCoder/GetQRCode', {
            url: window.location.href.replace(/huodeLive/, "huodeLiveMobile")
          })
            .then(res => {
              if (res.data.code == 200) {
                this.mobUrl = 'data:image/png;base64,' + res.data.data
              }
            })
        } else {
          if (res.code == 20) {
            this.qid = res.data.id
            //验证当前用户是否报名
            this.httphelper.get('/api/QuestionnaireApi/CheckIsFeedback?qid=' + res.data.id + '&userid=' + this.AuthorId).then(res => {
              if (res.code == 200) {
                //继续观看
                this.getMeetingInfo()
                //获取授权地址
                this.GetUserAuth();
                //菜单绑定
                this.getLiveMenuById();
                this.httphelper.post('/api/QRCoder/GetQRCode', {
                  url: window.location.href.replace(/huodeLive/, "huodeLiveMobile")
                })
                  .then(res => {
                    if (res.data.code == 200) {
                      this.mobUrl = 'data:image/png;base64,' + res.data.data
                    }
                  })
              } else {
                //跳转调查问卷 
                this.$alert('请先填写调查问题', '提示', {
                  confirmButtonText: '确定', callback: action => {
                    let callback = encodeURIComponent(window.location.href);
                    this.$router.push({
                      path: '/question?',
                      query: {
                        qid: this.qid,
                        callback: callback
                      },
                    })
                  }
                });
              }
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        }
      });
    }
  },
  created() {
    if (this.$cookies.isKey('token_chinagp')) {
      var _tokenkey = this.$cookies.get('token_chinagp');
      this.httphelper
        .post('/api/LoginApi/CheckToken', {
          tokenKey: _tokenkey
        })
        .then(res => {
          if (res.data.code == 200) {
            if (this.isMobile()) {
              window.location.href = window.location.href.replace(/huodeLive/, "huodeLiveMobile")
              //   this.$router.push({
              //     path: '/huodeLiveMobile',
              //     query: {
              //       id: this.$route.query.id,
              //       mid: this.$route.query.mid,
              //       tokenkey: _tokenkey
              //     }
              //   });
            }
            this.$cookies.set('token_chinagp', _tokenkey);
            //访问直播页面
            this.AuthorId = res.data.data.id;
            this.toLive();
          } else {

            this.$alert('请先登录', '提示', {
              confirmButtonText: '确定', callback: action => {
                this.toPcLogin('default')
              }
            });
          }
        });
    } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
      'tokenkey')) {
      this.httphelper
        .post('/api/LoginApi/CheckToken', {
          tokenKey: this.$route.query.tokenkey
        })
        .then(res => {
          if (res.data.code == 200) {
            if (this.isMobile()) {
              window.location.href = window.location.href.replace(/huodeLive/, "huodeLiveMobile")
              //   this.$router.push({
              //     path: '/huodeLiveMobile',
              //     query: {
              //       id: this.$route.query.id,
              //       mid: this.$route.query.mid,
              //       tokenkey: this.$route.query.tokenkey
              //     }
              //   });
            }
            this.$cookies.set('token_chinagp', this.$route.query.tokenkey);
            //访问直播页面
            this.AuthorId = res.data.data.id;
            this.toLive();
          } else {
            this.$alert('请先登录', '提示', {
              confirmButtonText: '确定', callback: action => {
                this.toPcLogin('default')
              }
            });
          }
        });
    } else {
      if (this.isMobile()) {
        window.location.href = window.location.href.replace(/huodeLive/, "huodeLiveMobile")
        // this.$router.push({
        //   path: '/huodeLiveMobile',
        //   query: {
        //     id: this.$route.query.id,
        //     mid: this.$route.query.mid
        //   }
        // });
      } else {
        this.$alert('请先登录', '提示', {
          confirmButtonText: '确定', callback: action => {
            this.toPcLogin('default')
          }
        });
      }
    }

  }
}
</script>
 

<style scoped>
.ifbox {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 20px;
  background-repeat: center;
  background-size: 1925px 1100px;
  background-image: url('../../assets/img/livebg.png');
  background-color: #eaf2fe;
  background-position: 50% 10px;
  overflow: hidden;
  position: relative;
}

.ifRight {
  height: 100%;
  width: 500px;
  background-color: #eaf2fe;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: 626px;
}

.ifLeft {
  height: 100%;
  width: 500px;
  background-color: #eaf2fe;
  position: absolute;
  right: 50%;
  top: 0;
  margin-right: 626px;
}

.ifTop {
  width: 100%;
  height: 20px;
  background-color: #eaf2fe;
  position: absolute;
  top: 0;
}

.ifBot {
  width: 100%;
  height: 20px;
  background-color: #eaf2fe;
  position: absolute;
  bottom: 0;
}

.ifMid {
  height: 100%;
  width: 8px;
  background-color: #eaf2fe;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: 310px;
}

.iframeLive {
  min-width: 1500px !important;
  height: 585px;
  border: none;
  margin: 0 auto;
}

.mobile {
  position: absolute;
  top: -139px;
  right: 50%;
  margin-right: -218px;
}

.mobbtn {
  height: 20px;
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 18px;
  color: rgb(94, 94, 94);
}

.mobbtn img {
  margin-right: 5px;
}

.mobbtn :hover {
  color: #448aff;
}

.mobbox {
  display: flex;
  align-items: center;
}

.mobboxl {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}

.mobboxr {
  text-align: center;
}

.mobboxr1 {
  font-size: 16px;
  color: #448aff;
}

.mobboxr2 {
  color: rgb(94, 94, 94);
}

.btitle {
  height: 60px;
  font-weight: 800;
  font-size: 18px;
}

.btitle img {
  margin-right: 20px;
}

.body {
  padding: 0 0 70px;
  position: relative;
}

.bodytop {
  padding: 30px 0 0;
}

.tuwenbox {
  padding: 20px 0;
}

.linkBox {
  width: 1000px;
}

.nextbutton1,
.prevbutton1,
.nextbutton2,
.prevbutton2 {
  display: inline-block;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  box-sizing: border-box;
  border-radius: 30px;
  background: #0b8586;
  color: #fff;
  position: absolute;
  top: 42%;
  z-index: 10;
  cursor: pointer;
  outline: none;
}

.nextbutton1,
.nextbutton2 {
  right: -30px;
  left: auto;
}

.prevbutton1,
.prevbutton2 {
  right: auto;
  left: -30px;
}

.wrap_content {
  position: relative;
  padding: 30px 0;
}

.my-button-disabled {
  background: #ddd;
  color: #999;
}

.video-card {
  width: 280px;
  height: 210px;
  padding: 10px 15px;
  background-color: #f6f4fa;
  box-sizing: border-box;
  position: relative;
}

.video-card .cont_img {
  width: 250px;
  height: 140px;
  border-radius: 5px 5px 0 0;
}

.video-card .btn {
  position: absolute;
  top: 65px;
  left: 130px;
  cursor: pointer;
}

.video-card p {
  height: 50px;
  border-radius: 0 0 5px 5px;
  background-color: #fff;
  margin-top: -3px;
  line-height: 20px;
  font-size: 14px;
  padding: 6px 5px 10px;
  box-sizing: border-box;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>